// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdVy_p {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
}

.IaNHAn {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.WtDBIl {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.xbdRNr {
  font-weight: var(--font-weight-semibold);
}

.DxTs9T {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: var(--spacing-2);
}

.jUO1H9 {
  display: flex;
  gap: var(--spacing-1);
  justify-content: center;
  align-items: center;
  width: 100%;
}

.paVzFR {
  width: 48px;
  height: 57px;
  text-align: center;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-lg);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  background: var(--surface-neutral-softer, #fafafa);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
  outline: none;
  box-sizing: border-box;
}

.paVzFR:focus {
  border-color: var(--surface-primary-medium, #d64000);
  background: var(--surface-neutral-white, #ffffff);
}

.paVzFR:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bedaHp {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-100);
  letter-spacing: 0px;
  color: var(--status-error, #dc0a0a);
  margin: var(--spacing-1) 0 0 0;
  padding: 0;
  text-align: center;
}

.owoEv2 {
  background: none;
  border: none;
  padding: 0;
  padding-top: var(--spacing-1-5, 12px);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: var(--text-neutral-silver, #cccccc);
  transition: color 0.2s;
}

.XHfpr_ {
  color: var(--text-primary-medium, #d64000);
}

.owoEv2:hover:not(:disabled) {
  opacity: 0.8;
}

.owoEv2:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: var(--text-neutral-silver, #cccccc);
}

.vyo7dJ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 19.9px;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
  text-align: center;
}

.fBm92b {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 19.9px;
  letter-spacing: 0px;
  color: var(--link-default);
  text-decoration: underline;
  margin: 0;
  transition: opacity 0.2s;
  vertical-align: middle;
}

.fBm92b:hover:not(:disabled) {
  opacity: 0.8;
}

.fBm92b:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.eO9SQg {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: var(--spacing-2);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/Onboarding/components/TokenValidation/TokenValidation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,kDAAkD;EAClD,uDAAuD;EACvD,mCAAmC;EACnC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;EACpD,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,eAAe;EACf,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,SAAS;EACT,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,4BAA4B;AAC9B","sourcesContent":[".tokenValidationWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.tokenValidationTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.tokenValidationSubtitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.tokenValidationSubtitleHighlight {\n  font-weight: var(--font-weight-semibold);\n}\n\n.tokenValidationPinContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: var(--spacing-2);\n}\n\n.tokenValidationPinInputs {\n  display: flex;\n  gap: var(--spacing-1);\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.tokenValidationPinInput {\n  width: 48px;\n  height: 57px;\n  text-align: center;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-lg);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  background: var(--surface-neutral-softer, #fafafa);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n  outline: none;\n  box-sizing: border-box;\n}\n\n.tokenValidationPinInput:focus {\n  border-color: var(--surface-primary-medium, #d64000);\n  background: var(--surface-neutral-white, #ffffff);\n}\n\n.tokenValidationPinInput:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tokenValidationError {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-100);\n  letter-spacing: 0px;\n  color: var(--status-error, #dc0a0a);\n  margin: var(--spacing-1) 0 0 0;\n  padding: 0;\n  text-align: center;\n}\n\n.tokenValidationWhatsappButton {\n  background: none;\n  border: none;\n  padding: 0;\n  padding-top: var(--spacing-1-5, 12px);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: 100%;\n  letter-spacing: 0px;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--text-neutral-silver, #cccccc);\n  transition: color 0.2s;\n}\n\n.tokenValidationWhatsappButtonActive {\n  color: var(--text-primary-medium, #d64000);\n}\n\n.tokenValidationWhatsappButton:hover:not(:disabled) {\n  opacity: 0.8;\n}\n\n.tokenValidationWhatsappButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  color: var(--text-neutral-silver, #cccccc);\n}\n\n.tokenValidationWaitText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 19.9px;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n\n.tokenValidationResendLink {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 19.9px;\n  letter-spacing: 0px;\n  color: var(--link-default);\n  text-decoration: underline;\n  margin: 0;\n  transition: opacity 0.2s;\n  vertical-align: middle;\n}\n\n.tokenValidationResendLink:hover:not(:disabled) {\n  opacity: 0.8;\n}\n\n.tokenValidationResendLink:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tokenValidationActions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  margin-top: var(--spacing-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tokenValidationWrapper": `mdVy_p`,
	"tokenValidationTitle": `IaNHAn`,
	"tokenValidationSubtitle": `WtDBIl`,
	"tokenValidationSubtitleHighlight": `xbdRNr`,
	"tokenValidationPinContainer": `DxTs9T`,
	"tokenValidationPinInputs": `jUO1H9`,
	"tokenValidationPinInput": `paVzFR`,
	"tokenValidationError": `bedaHp`,
	"tokenValidationWhatsappButton": `owoEv2`,
	"tokenValidationWhatsappButtonActive": `XHfpr_`,
	"tokenValidationWaitText": `vyo7dJ`,
	"tokenValidationResendLink": `fBm92b`,
	"tokenValidationActions": `eO9SQg`
};
module.exports = ___CSS_LOADER_EXPORT___;
